import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeProductImageUrl } from "@faire/web--source/common/transform-images";
import { TransparencyOverlay } from "@faire/web--source/ui/TransparencyOverlay";
import React from "react";
import styled from "styled-components";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
export var ImageGrid = function(props) {
    var images = props.images, imageSize = props.imageSize, _props_gap = props.gap, gap = _props_gap === void 0 ? "2px" : _props_gap, className = props.className;
    var fallbackImages = new Array(3).fill(undefined);
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsx(Grid, {
        $gap: gap,
        className: className,
        children: images.concat(fallbackImages).slice(0, 3).map(function(image, index) {
            return /*#__PURE__*/ _jsxs(ImageWrapper, {
                $isFirst: index === 0,
                $gap: gap,
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: image ? optimizeProductImageUrl(image, isSSR, imageSize) : EAEAEA_PIXEL
                    }),
                    image ? /*#__PURE__*/ _jsx(TransparencyOverlay, {}) : null
                ]
            }, index);
        })
    });
};
var ImageWrapper = styled.div.withConfig({
    componentId: "sc-1377c8ec-0"
})([
    "position:relative;width:100%;padding-top:calc(100% - ",
    ");",
    " img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}"
], function(props) {
    return props.$gap;
}, function(props) {
    return props.$isFirst ? "grid-row: 1 / span 2;" : "";
});
var Grid = styled.div.withConfig({
    componentId: "sc-1377c8ec-1"
})([
    "display:grid;grid-template-columns:2fr 1fr;grid-template-rows:1fr 1fr;grid-gap:",
    ";flex-shrink:0;"
], function(props) {
    return props.$gap;
});
